// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const componentStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'anchor-scroll': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'if-needed', 'inline'],
    description: 'Smooth, performant scrolling to named anchors on a page',
  },
  'animated-svg': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default', 'animated-svg-list', 'loading-methods'],
    description:
      'Component used to display animated Scalable Vector Graphics (SVG)',
  },
  'annotation-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'no-animation'],
    description: 'Indicator for a note of explanation or comment',
  },
  badge: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: [
      'default',
      'corporate',
      'exam',
      'membership',
      'preferred-freelancer',
      'recruiter',
      'rising-star',
      'sizes',
      'staff',
      'user',
      'verified',
    ],
    description: 'Badges that represent a user subscription',
  },
  'banner-alert': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'bordered', 'closeable', 'compact', 'level', 'types'],
    description: 'Banners which inform users about important things',
  },
  'banner-announcement': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'buttons'],
    description:
      'Banners for extremely important messages that affect the whole website',
  },
  'banner-upsell': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: [
      'default',
      'adding-button',
      'adding-image',
      'colors',
      'picture-position',
      'sizes',
    ],
    description: 'Banner for promoting products, suited to content-heavy pages',
  },
  breadcrumbs: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: ['default', 'current', 'disabled', 'mobile-show-breadcrumb'],
    description:
      "Breadcrumb trails that show a page's position in the site hierarchy",
  },
  button: {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'button-group',
      'button-icons',
      'button-link',
      'colors',
      'example',
      'hierarchy',
      'responsive',
      'sizes',
      'states',
    ],
    description: 'Clickable elements for anything you want people to click on',
  },
  callout: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop',
      'border-radius',
      'colors',
      'crawlable',
      'delay',
      'edge-to-edge',
      'hide-close-button',
      'hover',
      'inline',
      'mobile-dropdown',
      'mobile-fullscreen',
      'placement',
      'sizes',
      'smart-positioning',
    ],
    description: 'Popouts for rich tooltips',
  },
  'camera-input': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'custom-title-and-cta', 'trigger-type'],
    description:
      'Modal that opens on top of the main content and activates the device camera',
  },
  'card-list': {
    path: '',
    tags: ['cards'],
    internalOnly: true,
    stories: ['default', 'select-color', 'selectable', 'sizes'],
    description:
      'Styled list of selectable cards with predefined interactive states',
  },
  card: {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'border',
      'border-color',
      'clickable',
      'closeable',
      'edge-to-edge',
      'expandable',
      'flex-align-items',
      'flex-direction',
      'flex-justify-content',
      'header-right',
      'highlight',
      'levels',
      'ribbon-implementation',
      'sizes',
      'tabs-implementation',
    ],
    description:
      'Wrapping containers for consistently styled cards, used instead of custom CSS',
  },
  carousel: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'animation-speed',
      'arrow-backdrop',
      'arrow-icon',
      'arrow-position',
      'autoplay',
      'dot-indicator',
      'dot-indicator-position',
      'scroll-behaviour',
      'show-peek-slide',
      'wrap-around',
    ],
    description:
      'Slideshow that shows one or more images at a time and cycles through them',
  },
  chart: {
    path: '',
    tags: ['charts'],
    internalOnly: true,
    stories: ['default'],
    description: 'Graphical representation of data in a form of bar.',
  },
  'checkbox-card': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'border',
      'colors',
      'disable',
      'hide-checkbox',
      'level',
      'validation',
    ],
    description: 'Checkbox input with built-in layouting subcomponents',
  },
  checkbox: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'disable', 'size', 'validation'],
    description:
      'Checkboxes for choosing zero, one or more items from a range of options',
  },
  container: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: ['default', 'mobile-padding', 'sizes'],
    description:
      'Centres content at standard maximum widths, with no padding on mobile',
  },
  'countdown-timer': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A countdown timer with a circular progress bar showing the time remaining',
  },
  'currency-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'budget',
      'budget-type',
      'disabled-options',
      'label',
      'loading',
      'option-visibility',
      'type',
    ],
    description: 'Currency input field for use with CurrenciesCollection',
  },
  'date-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'compact-date-input', 'date-range', 'disabled'],
    description:
      'A text input that picks a date or a date range from a calendar',
  },
  'date-range-calendar': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Always-open date range calendar for filter panels and callouts',
  },
  'display-card': {
    path: '',
    tags: ['cards'],
    internalOnly: true,
    stories: ['default', 'entry-card-implementation', 'levels'],
    description: 'Cards with built-in header, image, content and footer slots',
  },
  drawer: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop-behavior',
      'edge-to-edge',
      'full-height-draggable',
      'full-width',
      'handler-bottom-margin',
      'hide-close-button',
      'overlay-stacking',
      'position',
      'sizes',
    ],
    description:
      'Overlay panel that slides in from the screen edge to show additional content',
  },
  'dropdown-filter': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'autoclose',
      'content-size',
      'disabled',
      'display',
      'edge-to-edge',
      'filter-applied',
      'full-width',
      'hide-dropdown-icon',
      'icon-fill',
      'icon-label',
      'icon-only',
      'logo',
      'mobile-dropdown',
      'mobile-dropdown-bottom',
      'size',
      'text-button',
      'unread-indicator',
    ],
    description:
      'Button that opens a rich popout of filtering or sorting options',
  },
  'emoji-picker': {
    path: '',
    tags: ['messaging / conversational ui'],
    internalOnly: true,
    stories: ['default', 'picker-size'],
    description: 'A emoji selector',
  },
  'file-display': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'filename', 'icon-types', 'sizes', 'types'],
    description: "Shows a file's image thumbnail, or an icon for its file type",
  },
  'file-select': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'attachment-icon',
      'button',
      'custom-content',
      'file-type-hint',
      'note',
      'preview',
      'validation',
    ],
    description:
      "File attachment UI with drag-and-drop or icon modes; it doesn't upload files",
  },
  'file-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Previews files in a native viewer on mobile apps and in a modal on desktop',
  },
  flag: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'sizes'],
    description: 'Icons for displaying country flags',
  },
  'floating-action': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'colors', 'icon-only', 'positions', 'sizes'],
    description:
      'Floating action is used to notify and provide action for the user.',
  },
  focus: {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default', 'autofocus'],
    description: 'A service for focusing elements',
  },
  fonts: {
    path: '',
    tags: ['typography'],
    internalOnly: false,
    stories: ['font', 'titles', 'subtitles', 'body', 'buttons', 'links'],
    description:
      'Learn how we integrate typography across our product ecosystem.',
  },
  'form-save': {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default'],
    description: 'Form Save',
  },
  'gallery-grid': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'aspect-ratio',
      'hide-filename',
      'max-columns',
      'max-rows',
      'reordering',
      'responsive',
      'showcase-card',
      'zoom-on-hover',
    ],
    description:
      'Grid preview of images and files, with adjustable columns and rows',
  },
  'gallery-mosaic': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: [
      'default',
      'interactive-content',
      'item-spacing',
      'rounded-corners',
      'single-image-fit',
    ],
    description:
      'Mosaic grid previews of images and other files, laid out by item count',
  },
  'generic-error': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'align', 'custom-retry', 'font-style', 'message'],
    description:
      'Generic error message with standard instructions and actions for unknown errors',
  },
  grid: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: ['default', 'alignment', 'offsetting', 'reordering'],
    description: 'Responsive 12-column Flexbox grid system, built mobile first',
  },
  'highlight-text': {
    path: '',
    tags: ['typography'],
    internalOnly: true,
    stories: [
      'default',
      'anchor-scroll',
      'background-color',
      'inline',
      'text-color',
    ],
    description:
      'Styled text for showing text with specific chunks highlighted',
  },
  highlight: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: ['default', 'callout', 'round-corners'],
    description: 'Highlighting a component',
  },
  hr: {
    path: '',
    tags: ['typography'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'font-weight',
      'text-sizes',
      'text-transform',
      'with-text',
    ],
    description:
      'A horizontal divider between sections; check Card and List Item first',
  },
  icon: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop',
      'button',
      'click-animation',
      'colors-and-sizes',
      'disabled',
      'drop-shadow',
      'hover-animation',
      'icon-font-list',
      'icon-font-weight',
      'ng-icon-list',
      'offset',
      'use-ng-icon',
    ],
    description:
      'Icons from our icon set; ask Design or UI Engineering to add a missing one',
  },
  'image-cropper': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default', 'aspect-ratio'],
    description:
      'Crops and resizes base64 images, with a set aspect ratio and output format',
  },
  'infinite-scroll': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'page-size'],
    description:
      'Infinite scrolling that emits a new limit when more data should load',
  },
  input: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'align',
      'animated-placeholders',
      'background-color',
      'button',
      'disabled',
      'edit-inline',
      'edit-inline-title-size',
      'hint',
      'icons',
      'keyboard-type',
      'labels',
      'max-character',
      'max-length',
      'min-value',
      'sizes',
      'states',
      'types',
      'usage',
      'validation',
    ],
    description: 'Inputs that accept typed input from users',
  },
  label: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Form input labels built on the HTML label element, with screen-reader support',
  },
  link: {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'animated-icon',
      'capitalization',
      'colors',
      'flex',
      'hover-colors',
      'link-action',
      'link-icon',
      'sizes',
      'types',
    ],
    description:
      'Anchor tags for links in a line of text, or actions where a button is too big',
  },
  list: {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: [
      'default',
      'bordered',
      'checkbox',
      'clickable',
      'dismiss',
      'expandable',
      'horizontal-padding',
      'keyboard-boundary',
      'keyboard-support',
      'ordered-unordered',
      'padding',
      'radio',
      'selectable',
      'selected',
      'toggle',
      'transparent',
    ],
    description:
      'Vertical lists, including radio, checkbox and toggle item types',
  },
  'loading-template': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Animated placeholders shown while content loads, to reduce layout jitter',
  },
  'location-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'detect-location',
      'disabled',
      'display-postal-code',
      'set-value',
    ],
    description:
      'Autocompleting location input that sets latitude and longitude on its control',
  },
  logo: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'background-color', 'sizes'],
    description:
      'The Freelancer logo, which can change color to suit a themed background',
  },
  map: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'custom-markers',
      'hide-landmarks',
      'interactive',
      'sizes',
      'tooltip',
    ],
    description:
      'Static Google Maps image for showing freelancer and project locations',
  },
  margin: {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: ['custom-margins'],
    description:
      "Tailwind margin utilities that use the design system's spacing tokens",
  },
  'media-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'adding-caption',
      'download-gallery-item',
      'enabling-zoom-click-animation',
      'inline-mode',
      'media-types',
      'modal-mode',
      'photo-rotations',
    ],
    description: 'Modal viewer for showcasing a set of images and other files',
  },
  modal: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'closeable',
      'colors',
      'edge-to-edge',
      'mobile-custom-view-header',
      'mobile-fullscreen',
      'rounded-close-button',
      'sizes',
    ],
    description:
      'Overlay that blocks the main content until it is explicitly interacted with',
  },
  'more-options': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'disabled',
      'icon-type',
      'mobile-dropdown',
      'sizes',
    ],
    description: 'Compact list of additional action items',
  },
  'multi-select': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'adding-text',
      'allow-input-on-blur',
      'counter',
      'dropdown-item-select-color',
      'dropdown-overlay',
      'hide-input-on-non-empty',
      'invalid-inputs',
      'items',
      'max-length',
      'max-rows',
      'options',
      'secondary-placeholder',
      'show-highlight-initially',
      'show-plus-icon',
      'validation',
    ],
    description: 'Multiselects for typing multiple options',
  },
  'multiple-location-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'sizes'],
    description:
      'Autocompleting "from" and "to" location inputs that can be swapped or cleared',
  },
  'new-feature-tag': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: ['default'],
    description: 'Displays a unique tag to show that something is new.',
  },
  'online-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'border', 'responsive', 'sizes'],
    description: 'Indicator if user is online or offline',
  },
  'otp-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Single-digit input boxes for one-time codes that move focus as you type',
  },
  'page-layout': {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: [
      'default',
      'min-height',
      'page-size',
      'secondary',
      'split-extend',
    ],
    description:
      'Base page wrapper with standard background colour, max width and min height',
  },
  pagination: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: ['default', 'compact', 'extremeties', 'mobile-compact', 'outline'],
    description: 'Pagination buttons only; the paging logic is up to you',
  },
  'phone-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'auto-focus',
      'country-priority',
      'default-country',
      'validation',
    ],
    description: 'Phone number input field for use with CountriesCollection',
  },
  picture: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'aspect-ratio-value',
      'background-image',
      'bounded-height',
      'bounded-width',
      'fallback',
      'fixed-aspect-ratio',
      'full-width',
      'image-sources',
      'lazy-load',
      'object-fit',
      'preload-image',
      'width-and-height',
      'zoom-on-hover',
    ],
    description:
      'Media components that display asset images from a map of one or more images',
  },
  'progress-bar': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: [
      'default',
      'checkpoints',
      'colors',
      'rounded-corners',
      'secondary-progress',
      'show-progress-marker',
      'sizes',
      'vertical-orientation',
    ],
    description:
      'Bar for showing unitless progress, with values bound to 0 to 100',
  },
  'progress-steps': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: [
      'default',
      'center-edge-text',
      'changing-orientation',
      'clickable-steps',
      'hide-callout',
      'mobile-large-indicator',
      'skipped-steps',
      'start-step',
      'substep',
      'type',
      'vertical-orientation',
    ],
    description:
      'A widget for showing progress of the user on a funnel with multiple steps',
  },
  'pull-refresh': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'drawer-type', 'scroll-basis', 'spinner-type'],
    description:
      'Pull-to-refresh container that triggers when pulled down from the top',
  },
  radio: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'disable', 'size', 'validation'],
    description:
      'Radio buttons, used in groups, for selecting one of a set of related options',
  },
  rating: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: [
      'default',
      'background-color',
      'compact',
      'half-rating',
      'inline',
      'read-only',
      'review-count',
      'size',
      'ticks-color',
      'type',
      'validation',
    ],
    description:
      'Five-star rating that users who work together give each other',
  },
  'relative-time': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: [
      'default',
      'color',
      'include-seconds',
      'input-types',
      'responsive',
      'secondary-unit',
      'short-format',
      'size',
      'static',
      'strict',
      'suffix',
      'time-passed',
      'weight',
    ],
    description: 'Simple time-ago components with optional live updating',
  },
  ribbon: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'colors', 'icon', 'placement'],
    description: 'Coloured strips used to highlight components',
  },
  search: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'borderless',
      'expandable',
      'round-corners',
      'with-custom-control',
      'with-custom-left-icon',
      'with-debounce-time',
      'with-scrollable-search-results',
      'without-result-display',
    ],
    description:
      'General purpose search with optional rich results rendered from item templates',
  },
  'segmented-date-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'bounds', 'calendar', 'disabled'],
    description:
      'Date input split into day, month and year fields, with a calendar as backup',
  },
  select: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'disabled',
      'flags',
      'grouped-options',
      'key-value-object',
      'sizes',
      'validation',
    ],
    description: 'Inputs for selecting from a menu of items',
  },
  'share-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'mobile', 'shareicons', 'showtext', 'sizes'],
    description: "Social Media Platform's sharing buttons",
  },
  'share-link': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default'],
    description: 'Component that allows users to copy a shareable link.',
  },
  slider: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'double', 'label-position'],
    description:
      'Slider for choosing a value, or a range with two handles, within set bounds',
  },
  'smart-textarea': {
    path: '',
    tags: ['forms', 'popups / overlays'],
    internalOnly: false,
    stories: ['default', 'callout-positioning', 'callout-visibility'],
    description:
      "Textarea that shows customized callouts based on the user's text selection",
  },
  'social-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'colors', 'fluid', 'share-buttons', 'sizes'],
    description:
      'Icons for linking to social media platforms or providing sharing buttons',
  },
  spinner: {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default', 'bird', 'overlay', 'sizes-and-colors'],
    description: 'A component that indicates loading or processing',
  },
  'split-button': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'full-width',
      'icons',
      'links',
      'responsive',
      'sizes',
      'states',
    ],
    description:
      'Button with a default action and a drop-down list of other predefined actions',
  },
  'sticky-footer': {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: ['default', 'alignment', 'fixed'],
    description:
      'Mobile footers for the bottom of the view, with padding and notch support',
  },
  table: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: [
      'default',
      'edge-to-edge',
      'expandable',
      'expandable-mobile',
      'fixed-layout',
      'flash-highlight',
      'header-color',
      'header-font-weight',
      'highlight',
      'highlight-border',
      'hover',
      'mobile-view-compact',
      'mobile-view-shading',
      'no-border',
      'no-wrap',
      'padding-size',
      'pagination',
      'pagination-position',
      'responsive',
      'row-links',
      'row-track-by',
      'separators',
      'sortable',
      'text-align',
      'title-callout',
      'vertical-alignment',
    ],
    description:
      'Tables for dynamic data; follow the examples closely, including the #cell ref',
  },
  tabs: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'bordered',
      'colors',
      'direction',
      'icon',
      'image',
      'media-position',
      'more-options',
      'router',
      'router-with-query',
      'size',
      'subtitle',
      'truncate',
    ],
    description:
      'Tabs for switching between views, with a color input for light or dark text',
  },
  'tag-status': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: [
      'default',
      'background-color',
      'colors',
      'icon',
      'sizes',
      'usage',
    ],
    description: 'Displays the status of the project / contest',
  },
  tag: {
    path: '',
    tags: ['tags'],
    internalOnly: false,
    stories: [
      'default',
      'borderless',
      'colors',
      'icon-only',
      'icons',
      'link',
      'max-lines',
      'selectable',
      'sizes',
      'types',
    ],
    description:
      'Tags for skills or filters, which can be clicked or dismissed',
  },
  text: {
    path: '',
    tags: ['typography'],
    internalOnly: true,
    stories: [
      'default',
      'align',
      'colors',
      'decoration',
      'highlight',
      'max-lines',
      'responsive',
      'sizes',
      'styles',
      'transform',
      'weights',
      'whitespace',
    ],
    description: 'Text that is styled via the tailwind utility classes.',
  },
  textarea: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'auto-grow',
      'border-radius',
      'borderless',
      'clear-button',
      'disabled',
      'display-character-count',
      'events',
      'icon-start',
      'max-character',
      'max-height',
      'max-length',
      'placeholder-color',
      'prevent-newlines',
      'validation',
    ],
    description: 'Multi-line inputs for forms',
  },
  'thumbnail-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'group-scrolling', 'hide-arrows'],
    description: 'A slideshow for cycling through a list of thumbnails',
  },
  timepicker: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'validation'],
    description:
      'Time input with a dropdown of options at set intervals, built on MatTimepicker',
  },
  'toast-alert': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: [
      'default',
      'closeable',
      'colors',
      'dynamic',
      'persist-when-hover',
      'types',
    ],
    description:
      'Brief one-line non-critical alerts shown top center, just below the header nav',
  },
  'toggle-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'equal-option-width',
      'full-width',
      'icons',
      'size',
      'variant',
    ],
    description:
      'Group of toggle buttons bound to a FormControl, built on fl-button',
  },
  toggle: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'colors', 'sizes', 'states'],
    description: 'Toggle switches for switching between two states or options',
  },
  tooltip: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Floating, non-actionable label that explains a UI element or adds information',
  },
  'unread-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'border', 'color', 'counter', 'position', 'sizes'],
    description: 'Indicator for unread messages',
  },
  'user-activity-status': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default'],
    description:
      'Shows whether a user is online, or when they were last active within 24 hours',
  },
  'user-avatar': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'group',
      'letter',
      'loading',
      'online-status',
      'responsive',
      'sizes',
      'video-avatar',
    ],
    description:
      'User profile images in several sizes, with corporate and online indicators',
  },
  'validation-error': {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default', 'custom'],
    description:
      "Error text shown on invalid form fields once they're touched or dirtied",
  },
  'video-modal': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: ['default'],
    description: 'Modal that wraps the video player',
  },
  video: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'auto-hide-controls',
      'auto-play',
      'auto-play-on-hover',
      'disable-controls',
      'object-fit',
      'playback-speed',
      'time-display',
    ],
    description: 'Media players for playing video files, built on Videogular',
  },
  'view-header': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'backgrounds', 'show-back-button'],
    description:
      'Mobile headers that give context and navigation at the top of views',
  },
  widget: {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description: 'The widget card display the information in a single element.',
  },
};
